<app-navbar [title]="transport.name">
	<a class="btn btn-primary me-4" routerLink="../copy"> <i class="fas fa-copy"></i> Kopiuj do innych dat </a>
	<a class="btn btn-warning me-4" routerLink="../"> <i class="fas fa-map-marked-alt"></i> Mapa </a>
	<button class="btn btn-danger me-4"><i class="fas fa-check"></i> Zapisz</button>
</app-navbar>

<app-map-timetable [(data)]="data" [citiesConnections]="citiesConnections" [side]="transport.side"></app-map-timetable>
